/* Local candidate. Native Shopify search remains responsible for all matching. */
(function (root) {
  'use strict';

  const values = {
    real: new Set(['1/2', '1', '2', '4', '8', '20']),
    escudo: new Set(['1', '2', '4', '8']),
    maravedi: new Set(['1', '2', '4', '6', '8', '16']),
  };
  const units = /(?<![\p{L}\p{N}])(?:real(?:es)?|escudos?|maraved[ií]s?)(?![\p{L}\p{N}])/giu;
  const denomination = /(?:1\s*\/\s*2|medio|\d+)\s+(real(?:es)?|escudos?|maraved[ií]s?)(?![\p{L}\p{N}])/giu;

  function prefix(nominal) {
    return `title:"${nominal}"${nominal === '2 reales' ? ' -title:"1/2 real"' : ''}`;
  }

  function parse(input) {
    if (typeof input !== 'string') return null;
    const text = input.normalize('NFC').trim().replace(/\s+/gu, ' ');
    // Do not reinterpret existing Shopify syntax, alternatives, or numeric ranges.
    if (!text || /[:"“”(){}\[\]*\\<>!=|]/u.test(text) || /\b(?:AND|OR|NOT)\b/iu.test(text)
      || /(?:^|\s)[+−-]\S/u.test(text)) return null;
    if ((text.match(units) || []).length !== 1) return null;
    const matches = Array.from(text.matchAll(denomination));
    if (matches.length !== 1) return null;
    const match = matches[0];
    const before = text.slice(0, match.index);
    const after = text.slice(match.index + match[0].length);
    // Avoid treating the denominator, decimal tail, signed amount, or suffix as a nominal.
    if (/[\p{L}\p{N}]$/u.test(before) || /(?:[\/+−-]|\d[.,])\s*$/u.test(before)) return null;
    if (/\d\s*(?:o|y|u|a|al)\s*$/iu.test(before)) return null;
    if (/^\s*\//u.test(after)) return null;
    if (/^\s*(?:o|y|u|a|al)\s*(?:\d|medio)/iu.test(after)) return null;
    const unitText = match[1].toLowerCase().normalize('NFD').replace(/\p{M}/gu, '');
    const unit = unitText.startsWith('real') ? 'real' : unitText.startsWith('escudo') ? 'escudo' : 'maravedi';
    const amount = match[0].slice(0, -match[1].length).trim().toLowerCase().replace(/\s/gu, '').replace(/^medio$/u, '1/2');
    if (!values[unit].has(amount)) return null;
    const label = unit === 'real' ? (amount === '1' || amount === '1/2' ? 'real' : 'reales')
      : unit === 'escudo' ? (amount === '1' ? 'escudo' : 'escudos')
        : amount === '1' ? 'maravedí' : 'maravedís';
    const nominal = `${amount} ${label}`;
    // Retain the other search words; punctuation adjoining the removed phrase is a separator.
    const rest = `${before.replace(/[\s,;.]+$/u, '')} ${after.replace(/^[\s,;.]+/u, '')}`.trim();
    const display = `${nominal}${rest ? ` ${rest}` : ''}`;
    return { query: `${prefix(nominal)}${rest ? ` ${rest}` : ''}`, display, nominal };
  }

  function display(query) {
    if (typeof query !== 'string') return query;
    const match = /^title:"([^"]+)"/u.exec(query);
    if (!match) return query;
    const generatedPrefix = prefix(match[1]);
    if (!query.startsWith(generatedPrefix)) return query;
    const tail = query.slice(generatedPrefix.length);
    if (tail && !tail.startsWith(' ')) return query;
    const candidate = `${match[1]}${tail}`;
    const parsed = parse(candidate);
    return parsed && parsed.query === query ? parsed.display : query;
  }

  const api = Object.freeze({ parse, display });
  root.CoinsNumismaticSearch = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
